import { Component, OnInit } from '@angular/core';
import {AppSettingsService} from '../../../services/app-settings.service';
import {Response, StaticMethods} from '../../../model/GeneralModels';
import {Router} from '@angular/router';
import {AuthService} from '../../../services/auth.service';
import {IndividualAccidentsService} from '../../../services/individual-accidents.service';

@Component({
  selector: 'app-basic-information-confirm',
  templateUrl: './new-request-confirm.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/Content/src/css/ini.bime.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css',
  ]
})
export class NewRequestConfirmComponent implements OnInit {
  viewList: any = {};
  formsData: any = {};
  translation: any = {};
  icon: string;

  constructor(
    private services: IndividualAccidentsService,
    public settings: AppSettingsService,
    private router: Router,
    private authService: AuthService
  ) {
  }

  ngOnInit() {
    if (StaticMethods.checkState(this.router, ['formsData', 'viewList', 'translation'], '/individual-accidents/offers')) {
      this.formsData = history.state.formsData;
      this.viewList = StaticMethods.preserveList(history.state.viewList);
      this.translation = history.state.translation;
      console.log(this.viewList);
    }
  }

  setButton($event: number) {
    const buttonElement: HTMLElement = document.getElementById('1' + '_select_offer_button');
    buttonElement.style.display = 'none';
  }

  takeAction($event: number) {
  }

  goNext() {
    if (this.authService.decode() && this.authService.decode().Role === 'user') {
      this.services.createRequest(this.formsData).subscribe((response: Response) => {
        if (response.success) {
          this.router.navigate(['individual-accidents/details'], {state: {
              requestID: response.data
            }});
        }
      });
    } else {
      console.log(history.state);
      this.router.navigate(['login'],
        {
          queryParams: {returnUrl: 'individual-accidents/confirm'},
          state: history.state
        }
      );
    }
  }
}
